var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJuniors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-15",
    "data-name": "people"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.74 8.65a3.1 3.1 0 1 0 -3.09-3.09 3.09 3.09 0 0 0 3.09 3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.74 9.54h-4a3.78 3.78 0 0 0 -4 3.49v5a2.7 2.7 0 0 0 2 2.5v6.82a2.11 2.11 0 0 0 2 2.19h4a2.1 2.1 0 0 0 2-2.19v-6.82a2.7 2.7 0 0 0 2-2.5v-5.03a3.77 3.77 0 0 0 -4-3.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 16.51a1 1 0 0 0 -1.41 0l-.81.8v-4a1 1 0 0 0 -2 0v4l-.8-.8a1 1 0 0 0 -1.42 0 1 1 0 0 0 0 1.41l2.44 2.51a1 1 0 0 0 .7.3 1 1 0 0 0 .71-.3l2.59-2.51a1 1 0 0 0 0-1.41z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniors);
export default __webpack_public_path__ + "static/media/Juniors.0cfb0bd97df489800ca1ac8de0dba146.svg";
export { ForwardRef as ReactComponent };